import { render, staticRenderFns } from "./DesignCalendar.vue?vue&type=template&id=58b352fd&scoped=true&"
import script from "./DesignCalendar.vue?vue&type=script&lang=js&"
export * from "./DesignCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DesignCalendar.vue?vue&type=style&index=0&id=58b352fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b352fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCol,VIcon,VPagination,VRow})
